module.exports = __webpack_public_path__ + "resources/video_play_circle.749663a0726555a1.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-rcmd/img/video_play_circle.png
// module id = 755
// module chunks = 0 2